import { render, staticRenderFns } from "./stockvalue.vue?vue&type=template&id=65ba3d5e"
import script from "./stockvalue.vue?vue&type=script&lang=js"
export * from "./stockvalue.vue?vue&type=script&lang=js"
import style0 from "./stockvalue.vue?vue&type=style&index=0&id=65ba3d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports